import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export type ConditionInsights = {
  tideInsight: string;
  sunMoonInsight: string;
  tonightSky: string;
  weatherOverview: string;
  weatherUv: string;
  weatherWind: string;
  weatherPrecipitation: string;
  generated: boolean;
};

export type ConditionInsightsRequest = {
  householdId: string;
  dateKey: string;
  hourBucket: number;
  locationLabel: string;
  beachName: string;
  tideStationName: string;
  tides: Array<{ type: "High" | "Low"; time: string; height: number }>;
  sunrise: string;
  sunset: string;
  moonPhase: string;
  moonIllumination: number;
  nextMoonPhase: string;
  daysToNextMoonPhase: number;
  weather: {
    condition: string;
    temperature: number;
    apparentTemperature: number;
    high: number;
    low: number;
    relativeHumidity: number;
    uvIndex: number;
    windSpeed: number;
    windGust: number;
    windDirection: number;
    precipitationChance: number;
    precipitationAmount: number;
    precipitationHours: number;
  };
};

const generateConditionInsightsCall = httpsCallable<ConditionInsightsRequest, ConditionInsights>(
  functions,
  "generateConditionInsights",
  { timeout: 30_000 }
);

export async function getConditionInsights(input: ConditionInsightsRequest) {
  const response = await generateConditionInsightsCall(input);
  return response.data;
}
